function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Card({
  as: Component = "div",
  tone = "default",
  padding = "md",
  selected = false,
  className = "",
  children,
  ...props
}) {
  return (
    <Component
      {...props}
      className={joinClassNames(
        "lz-v2-card",
        `lz-v2-card--${tone}`,
        `lz-v2-card--padding-${padding}`,
        selected && "lz-v2-card--selected",
        className
      )}
    >
      {children}
    </Component>
  );
}
